// @flow

import React from 'react';
import type { Element } from 'react';

import type { FilterItemProps } from '../../types';

import { StyledCover, StyledLabel, StyledSubLabel } from './styles';

const Item = ({
  label, value, subLabel, isActive, onClick
}: FilterItemProps): Element<any> => (
  <StyledCover onClick={(event: Event) => onClick(event, value)}>
    <StyledLabel isActive={isActive}>{label}</StyledLabel>

    {subLabel && <StyledSubLabel>{subLabel}</StyledSubLabel>}
  </StyledCover>
);

export default Item;
